import React, { useRef } from "react";
import { View, StyleSheet } from "react-native";
import NtListRow from "../../components/NtListRow";
import NtModal from "../../components/NtModal";
import NtRingGroupUpdateForm from "./NtRingGroupUpdateForm";
import NtText from "../../components/NtText";
import NtBadge from "../../components/NtBadge";
import NtAccountDisplay from "./NtAccountDisplay";
import { usePermission } from "../../hooks/usePermission";
import { useTheme } from "../../context/ThemeContext";
import routes from "../../navigation/routes";
import settings from "../../config/settings";

function NtRingGroupItem({ item, columns, onUpdate, onDelete }) {
  const { theme } = useTheme();
  const updateModalRef = useRef();
  const permission = usePermission(
    settings.permissionTypeEdit,
    routes.ringgroup
  );

  const renderUpdateForm = () => {
    return (
      <NtModal ref={updateModalRef}>
        <NtRingGroupUpdateForm
          item={item}
          onCancel={() => {
            updateModalRef.current?.dismiss();
          }}
          onUpdate={() => {
            updateModalRef.current?.dismiss();
            if (onUpdate) {
              onUpdate();
            }
          }}
          onDelete={() => {
            updateModalRef.current?.dismiss();
            if (onDelete) {
              onDelete();
            }
          }}
        />
      </NtModal>
    );
  };

  return (
    <View style={styles.container}>
      <NtListRow
        item={item}
        columns={columns}
        renderCustom={(item, column) => {
          if (column == "ring_group_call_timeout") {
            return `${item[column]}s`;
          } else if (
            column == "ring_group_enabled" ||
            column == "ring_group_forward_enabled"
          ) {
            const enabled = !!item[column];
            return (
              <NtBadge variant={enabled ? "green" : "gray"}>
                {enabled ? "Enabled" : "Disabled"}
              </NtBadge>
            );
          } else if (column == "destination_numbers") {
            return (
              <View>
                {item[column]?.map((each) => (
                  <View
                    key={each}
                    style={{
                      paddingHorizontal: 7,
                      paddingVertical: 2,
                      borderRadius: theme.radius,
                      backgroundColor: theme.surface3,
                      marginBottom: 4,
                      alignSelf: "flex-start",
                    }}
                  >
                    <NtText style={{ fontSize: 11, color: theme.textDim }}>{each}</NtText>
                  </View>
                ))}
              </View>
            );
          } else if (column == "ring_group_timeout_action") {
            return <NtAccountDisplay item={item[column]} />;
          }
        }}
        onActionPress={
          permission
            ? () => {
                updateModalRef.current?.show();
              }
            : null
        }
      />
      {renderUpdateForm()}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtRingGroupItem;
